module.exports = __webpack_public_path__ + "static/logos-tiles-oreilly-0b01ed9ee71ec314265164978ee47f09.svg";